import { render, staticRenderFns } from "./ProjectPublicationTab.vue?vue&type=template&id=3c056dc6&"
import script from "./ProjectPublicationTab.vue?vue&type=script&lang=js&"
export * from "./ProjectPublicationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports